import { Button } from "components/DesignSystem/Button/Button";
import { ClockCounterClockwise } from "components/icons/ClockCounterClockwise";
import { Headset } from "components/icons/Headset";
import { useChannelAiStatus } from "hooks/useChannelAiStatus";
import { useChannelEscalationStatus } from "hooks/useChannelEscalationStatus";
import { useToast } from "hooks/useToast";
import { useUserAiStatus } from "hooks/useUserAiStatus";
import {
  HUMAN_SUPPORT_STATUS,
  useRequestHumanSupportMutation,
  useWithdrawHumanSupportMutation,
} from "store/apis/chatHumanSupport";
import { BackendError } from "types/utils/error";

type RequestHumanSupportProps = {
  groupId: string;
};

export const RequestHumanSupport = ({ groupId }: RequestHumanSupportProps) => {
  const { channelId, escalationStatus } = useChannelEscalationStatus();
  const { isAiEnabled: isChannelAiEnabled } = useChannelAiStatus();
  const { alertToast } = useToast();
  const { isAiEnabled: isUserAiEnabled } = useUserAiStatus();
  const [requestHumanSupport, { isLoading: isRequestingSupport }] =
    useRequestHumanSupportMutation();
  const [withdrawHumanSupport, { isLoading: isWithdrawingSupport }] =
    useWithdrawHumanSupportMutation();

  const handleRequestHumanSupport = async () => {
    try {
      await requestHumanSupport({ groupId, channelId }).unwrap();
    } catch (err) {
      alertToast({
        message: (err as BackendError).data?.error?.message,
      });
    }
  };

  const handleWithdrawRequest = async () => {
    try {
      await withdrawHumanSupport({ groupId, channelId }).unwrap();
    } catch (err) {
      alertToast({
        message: (err as BackendError).data?.error?.message,
      });
    }
  };

  if (
    escalationStatus === HUMAN_SUPPORT_STATUS.ACTIVE ||
    !isChannelAiEnabled ||
    !isUserAiEnabled
  ) {
    return null;
  }

  if (escalationStatus === HUMAN_SUPPORT_STATUS.PENDING) {
    return (
      <Button
        customType="secondary"
        size="small"
        isLoading={isWithdrawingSupport}
        onClick={handleWithdrawRequest}
      >
        <span className="t-flex t-items-center t-gap-1">
          <ClockCounterClockwise /> Withdraw request
        </span>
      </Button>
    );
  }

  return (
    <Button
      customType="secondary"
      size="small"
      isLoading={isRequestingSupport}
      onClick={handleRequestHumanSupport}
    >
      <span className="t-flex t-items-center t-gap-1">
        <Headset /> Request human support
      </span>
    </Button>
  );
};
